import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/images/logo-eaglem.svg'


const _hoisted_1 = { class: "tit" }
const _hoisted_2 = {
  key: 0,
  class: "staging-badge"
}
const _hoisted_3 = { class: "main-nav" }
const _hoisted_4 = { class: "nav-img" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "nav-text" }
const _hoisted_7 = { class: "login" }
const _hoisted_8 = { class: "text" }

import { ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { removeAuthToken } from '@/utils/auth'
import { useUserStore } from '@/stores/user'
import { ElNotification } from 'element-plus'
import { getEnvironmentConfig } from '@/utils/environment'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonHeader',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const useStore = useUserStore();


// 환경 설정 가져오기
const envConfig = computed(() => getEnvironmentConfig());


// console.log(envConfig.value);

const menuList = [
  'request',
  'customer'
]
const currentItem = ref('request')

watch(route, () => {
  currentItem.value = route.path.split('/')[1]
})
const handleLogout = () => {
  removeAuthToken();
  ElNotification({
    title: '성공',
    message: '정상적으로 로그아웃 되었습니다.',
    type: 'success',
    duration: 1500
  });
  router.push({ name: 'Login' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("header", {
    class: "header",
    style: _normalizeStyle({ backgroundColor: envConfig.value.headerBackgroundColor })
  }, [
    _createElementVNode("h1", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/request" }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Eagle M"
          }, null, -1)),
          (envConfig.value.isStaging)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Staging"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item) => {
        return _createVNode(_component_router_link, {
          to: `/${item}`,
          class: _normalizeClass(["nav-item", { current: currentItem.value === item }]),
          key: item,
          onClick: ($event: any) => (currentItem.value = item)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: require(`@/assets/images/nav-icons/icon-${item}.svg`),
                alt: item
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item), 1)
          ]),
          _: 2
        }, 1032, ["to", "class", "onClick"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, [
        _createElementVNode("b", null, _toDisplayString(_unref(useStore).user?.userId), 1),
        _cache[2] || (_cache[2] = _createTextVNode("님"))
      ]),
      _createVNode(_component_el_button, {
        size: "small",
        color: "#555555",
        class: "btn-logout",
        "aria-label": "Logout",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleLogout()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, { icon: "right-to-bracket" })
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})